import _ from 'lodash';

// Add new themes here + in storybook
const themes = ['light', 'dark'];

const loadThemes = async () => {
    let allThemes = {};
    for (const theme of themes) {
        const newTheme = await import(`../themes/${theme}.json`).then(
            (module) => module.default,
        );
        const themeName: string = newTheme.name;
        const themeObject = {
            [`${themeName.trim().toLowerCase()}`]: newTheme,
        };
        allThemes = _.merge(themeObject, allThemes);
    }
    return allThemes;
};

export { loadThemes, themes };
